import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { t } from '@/components/common/Helpers'

export default function StandardGallery({
    obituary,
    titleClasses = "app-title text-4xl mb-6 text-center text-gray-700",
    isPreviewMode = false
}) {
    return <div className="w-full max-w-screen-lg m-auto">
        {!isPreviewMode && 
            <div className="text-center mb-8 md:mb-12 px-4 md:px-8">
                <h2 className={titleClasses}>
                    {t.trans('obituaries.photo-gallery')}
                </h2>
            </div>
        }
        <ImageGallery
            items={obituary.gallery_photos.map((galleryPhoto, count) => ({
                original: galleryPhoto.xl,
                thumbnail: galleryPhoto.md,
                originalAlt: `${obituary.display_name} photo gallery image ${
                    count + 1
                } of ${obituary.gallery_photos.length}`,
                thumbnailAlt: `${
                    obituary.display_name
                } photo gallery thumbnail ${count + 1} of ${
                    obituary.gallery_photos.length
                }`,
                thumbnailLoading: "lazy",
                loading: "lazy",
            }))}
            showPlayButton={false}
            showBullets={obituary.gallery_photos.length <= 25}
            lazyLoad={true}
            showIndex={true}
            onClick={isPreviewMode ? () => {} : undefined}
            onThumbnailClick={isPreviewMode ? () => {} : undefined}
        />
    </div>;
}
